import { OnboardingLogout } from "@/components/onboarding/logout"
import { SiriOrb } from "@/components/ui/siri-orb"
import { useAssistant } from "@/hooks/use-assistant"
import { cn } from "@/lib/utils"
import { destroyUserSessionPath } from "@/routes"

import { type Step } from "./types"

// IMP-457: the assistant's orb stays in frame for the whole flow — center
// stage for the intro, docked smaller as the flow proceeds. Colors follow the
// partner's assistant theme (IMP-455).
const ORB_SIZE: Record<Step, number> = {
  intro: 180,
  voice: 96,
  business: 96,
  analyzing: 150,
  profile: 64,
  jobs: 64,
}

export function OnboardingShell({
  children,
  step,
}: {
  children: React.ReactNode
  step: Step
}) {
  const { theme } = useAssistant()

  return (
    <div className="bg-background relative flex min-h-svh flex-col items-center overflow-y-auto px-6">
      <OnboardingLogout sessionPath={destroyUserSessionPath()} />

      {/* The orb — always in frame, resizing with the step */}
      <div
        className={cn(
          "flex shrink-0 items-end justify-center transition-all duration-700",
          step === "intro" ? "pt-28 pb-10" : "pt-10 pb-6",
        )}
      >
        <SiriOrb
          size={ORB_SIZE[step]}
          colors={theme.colors}
          className="drop-shadow-xl transition-all duration-700"
        />
      </div>

      <div className="w-full max-w-xl pb-16">{children}</div>
    </div>
  )
}
